import { render, staticRenderFns } from "./CustomBreakpointsPanel.vue?vue&type=template&id=fc54c074&"
import script from "./CustomBreakpointsPanel.vue?vue&type=script&lang=ts&"
export * from "./CustomBreakpointsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports